import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Team.css'; 

const teamMembers = [
  {
    name: 'Brian Mwithi',
    role: 'CEO',
    image: './Brian Mwithi Profile.jpg',
    portfolio: 'https://janedoe.me'
  },
  {
    name: "Alec Ng'ang'a",
    role: ' Software Developer',
    image: 'https://media.licdn.com/dms/image/D4D03AQEo3TqyNh2PIA/profile-displayphoto-shrink_800_800/0/1709037225083?e=1714608000&v=beta&t=x67dH_URK11ebigE6wGcaNwcSGBcJzGqoOROfQi2N6o', 
    github: 'https://github.com/phsycomonkey',
    portfolio: 'https://janedoe.me'
  },
  {
    name: 'Kelvin Mue',
    role: ' Full-Stack Web Developer',
    image: 'Kelvin-mue_image.jpg', 
    github: 'https://github.com/Kmurll',
    portfolio: 'https://kelvin-portfolio-eight.vercel.app/'
  },
  {
    name: 'Ian Gichachi',
    role: ' Full-Stack Web Developer',
    image: './Ian Gichachi Picture.jpg', 
    github: 'https://github.com/i-gichachi',
    portfolio: 'https://ian-gichachi-portfolio.vercel.app/'
  },
  {
    name: 'Erick Kamau',
    role: 'Designer',
    image: './Cappy Image.jpg',
    portfolio: 'https://janedoe.me'
  }
];

const TeamMember = ({ member }) => (
  <div className="col-lg-4">
    <div className="team-item position-relative overflow-hidden">
      <img className="img-fluid w-100" src={member.image} alt={`Profile of ${member.name}`} onError={(e) => e.target.src = '/Connecto Logo.png'} />
      <div className="team-text w-100 position-absolute top-50 start-50 translate-middle text-center p-4">
        <h3>{member.name}</h3>
        <p className="text-uppercase mb-0">{member.role}</p>
      </div>
    </div>
  </div>
);

const Team = () => {
  return (
    <div className="container-fluid py-6 px-5">
      <div className="text-center mx-auto mb-5" style={{ maxWidth: "600px" }}>
        <h1 className="display-5 mb-0" style={{ color: "#8d2ab6" }}>Our Team Members</h1>
        <hr className="w-25 mx-auto bg-primary" />
      </div>
      <div className="row g-5">
        {teamMembers.map(member => <TeamMember key={member.name} member={member} />)}
      </div>
    </div>
  );
};

export default Team